var LanguageJSON = require('./Language.json')

var LANGUAGE = 'SE'

export function testJSON () {
  console.log(LanguageJSON)
}

export function setLanguage (language) {
  LANGUAGE = language
}

export function getLanguage () {
  return LANGUAGE
}

export function getOppositeLanguage () {
  switch (LANGUAGE) {
    case 'SE':
      return 'EN'
    case 'EN':
      return 'SE'
  }
}

export function getHeader (section) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].header.SE
    case 'EN':
      return LanguageJSON.section[section].header.EN
  }
}

export function getCategory (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].EN
  }
}

export function getCategoryForStart (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].start.SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].start.EN
  }
}

export function getCategoryHeader (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].header.SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].header.EN
  }
}

export function getCategorySummary (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].summary.SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].summary.EN
  }
}
export function getCategoryText (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].text.SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].text.EN
  }
}

export function getCategoryListHeader (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].listHeader.SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].listHeader.EN
  }
}

export function getCategoryList (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].list.SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].list.EN
  }
}

export function getSubcategories (section, category) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[section].categories[category].subcategories.SE
    case 'EN':
      return LanguageJSON.section[section].categories[category].subcategories.EN
  }
}

export function getSummary (id) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[id].summary.SE
    case 'EN':
      return LanguageJSON.section[id].summary.EN
  }
}

export function getText (id) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[id].text.SE
    case 'EN':
      return LanguageJSON.section[id].text.EN
  }
}

export function getQuote (id) {
  switch (LANGUAGE) {
    case 'SE':
      return LanguageJSON.section[id].quote.SE
    case 'EN':
      return LanguageJSON.section[id].quote.EN
  }
}



// WEBPACK FOOTER //
// ./src/LanguageController.js